import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_text = _resolveComponent("base-text")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_text, { class: "_mb-1" }, {
      default: _withCtx(() => [
        _cache[0] || (_cache[0] = _createTextVNode("Use the business balance ", -1 /* CACHED */)),
        _createVNode(_component_tooltip, {
          text: "The gross funds you can spend from your wallet",
          "icon-name": "circle-info",
          "data-qa": "business-wallet-balance-tooltip"
        })
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", {
      class: _normalizeClass($options.paymentOptionClassList)
    }, [
      _createVNode(_component_checkbox_field, {
        "model-value": true,
        "show-label": false,
        name: "walletPaymentOption",
        class: "_mt-0 _mr-2",
        "checked-value": true,
        type: "radio",
        disabled: true,
        "data-qa": "business-wallet-balance-option"
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_text, { "data-qa": "business-wallet-balance" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.businessBalanceLabel), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        ($options.showRemainingBalanceAfterPayment)
          ? (_openBlock(), _createBlock(_component_base_text, {
              key: 0,
              "data-qa": "business-wallet-balance-after-payment"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.remainingFundsAfterPaymentLabel), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(_component_base_icon, {
        size: "lg",
        name: "piggy-bank",
        class: "_ml-a _tc--accent"
      })
    ], 2 /* CLASS */),
    ($options.showNotEnoughFundsLabel)
      ? (_openBlock(), _createBlock(_component_base_text, {
          key: 0,
          as: "p",
          class: "_mt-3",
          "data-qa": "business-wallet-not-enough-funds"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($options.notEnoughFundsLabel), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}